// FieldCompact.js
import PropTypes from 'prop-types';
import { Box, Typography, Tooltip } from '@mui/material';

/**
 * Composant réutilisable pour afficher une ligne compacte (label + valeur).
 * @param {string} label Libellé du champ.
 * @param {string|number} value Valeur du champ.
 * @param {string} color Couleur de la valeur.
 * @param {boolean} shrink Active le shrink + tooltip si true.
 */
export function CompactNodeField({ label, value, color = 'text.primary', shrink = true }) {
  if (value == null) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        py: 0.5,
        px: 1,
        width: '100%',
        borderBottom: '1px solid #eee',
        '&:last-child': { borderBottom: 'none' }
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 400,
          color: 'text.secondary',
          flex: '0 0 60%',
          textAlign: 'left'
        }}
      >
        {label}
      </Typography>

      {shrink ? (
        <Tooltip title={value}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color,
              flex: '1 1 40%',
              textAlign: 'right',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {value}
          </Typography>
        </Tooltip>
      ) : (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color,
            flex: '1 1 40%',
            textAlign: 'right'
          }}
        >
          {value ?? '-'}
        </Typography>
      )}
    </Box>
  );
}

CompactNodeField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  shrink: PropTypes.bool
};
